import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  ClientProfileService,
  ControlItemsService,
} from '../../_services/index';

import {Role} from "../../helpers";
import {Constants} from "../../helpers/constants";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {WorkstreamItemComponent} from "../workstreamItem";
import {WorkstreamService} from "../../_services/workstream.service";
import {ConfirmComponent} from "../confirm";
import {WorkstreamComponent} from "../workstream/workstream.component";
import {UploadComplianceAreaComponent} from "../uploadComplianceArea";
import {WorkstreamUploadComponent} from "../workstreamUpload";
import {SelectItem} from "primeng/api";
import { Location } from '@angular/common';

@Component({
    standalone: false,
  selector: "workstreams",
  templateUrl: 'workstreams.component.html',
  styleUrls: ['./workstreams.component.scss'],
})

export class WorkstreamsComponent implements OnInit {

  workstreams: any[] = [];
  rowGroupIndexes: any[] = [];
  currentUser: any;
  draggedItem: any;
  public dialogRef: MatDialogRef<WorkstreamItemComponent, any>;
  cols: any[] = [
    { header: 'WS Item Name', field: 'wsid', width: '5%' },
    { header: 'Owner', field: 'ownerName', width: '15%', isMaster: false },
    { header: 'Controls', field: 'controlItemSummary', width: '25%' },
    { header: 'Description', field: 'descriptionSafe', width: '40%', fn: (value) => value ? value.substring(0, 50) + (value.length > 50 ? "..." : "") : "" },
    { header: 'Status', field: 'status', width: '5%', isMaster: false },
    {
      header: 'Due',
      field: 'dueDate',
      fn: (date) => date ? new Date(date).toLocaleDateString() : "",
      width: '5%',
      isMaster: false
    },
    {
      header: 'Modified',
      field: 'modifiedDate',
      fn: (date) => date ? new Date(date).toLocaleDateString() : "",
      width: '5%',
      isMaster: true
    },
  ];
  columnVisibility = {};
  columnOptions: SelectItem[];
  visibleColumns = {};
  rowGroupMetadata = {};
  filteredWorkstream: any[] = [];
  isFilterSelected = false;
  selectedFilter: { workstreamId: string, filterType: string } | null = null;
  expandedWorkstreams: {} = {};
  expandedWorkstreamItems: {} = {};
  controlItemIdFromRoute: any;
  complianceAreaControlIdFromFilter: any;

  exportCols;

  constructor(
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public router: Router,
    public clientProfileService: ClientProfileService,
    public workstreamService: WorkstreamService,
    public controlItemService: ControlItemsService,
    private location: Location) {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if (this.currentUser.role == Role.KingAdmin) {
      this.cols = this.cols.filter(c => !c.isMaster);
    }

    this.exportCols = [{header: 'Workstream', field: 'workstreamName'}].concat(this.cols);
  }

  ngOnInit() {
    this.clientProfileService.getUserSetting('WorkstreamTable').subscribe(r => {
      this.columnVisibility = (r || {}).columnVisibility || this.columnVisibility;
      this.columnOptions = [];
      for (let i = 0; i < this.cols.length; i++) {
        this.columnOptions.push({label: this.cols[i].header, value: this.cols[i]});
      }
      this.cols = this.cols.filter(col => this.columnVisibility[col.field] !== false);
      this.visibleColumns = this.cols.length;
    });

    this.route.queryParams.subscribe(params => {
      this.controlItemIdFromRoute = params['controlItemId'];
    });

    this.loadWorkStreams();
  }

  editWorkstreamItem(workstreamItem: any) {
    this.edit(WorkstreamItemComponent, {...workstreamItem});
  }

  createWorkstream() {
    this.edit(WorkstreamComponent, {
      name: ""
    });
  }

  createWorkstreamItem(workstream) {
    this.edit(WorkstreamItemComponent, {
      wsid: "",
      keyResources: "",
      description: "",
      ownerId: null,
      dueDate: null,
      status: "",
      workstreamId: workstream.workstreamId,
      type: "",
      workstreamName: workstream.name
    })
  }

  editWorkstream(workstream: any) {
    console.log(workstream)
    this.edit(WorkstreamComponent, {name: workstream.workstreamName, workstreamId: workstream.workstreamId});
  }

  public edit(component, item: any) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        entity: item
      }
    };

    this.dialogRef = this.dialog.open(component, config);

    this.dialogRef.afterClosed().subscribe((result: any) => {
      this.ngOnInit();
    });
  }

  public deleteWorkstreamItem(workstreamItem) {
    this.delete('Workstream Item', (item) => this.doDeleteWorkstreamItem(item), workstreamItem);
  }

  public deleteWorkstream(workstream) {
    this.delete('Workstream', (item) => this.doDeleteWorkstream(item), workstream);
  }

  public delete(name, callback, item) {
    this.dialog.open(ConfirmComponent, {
      data: {
        title: 'Do you want to delete this ' + name + '?',
        yes: 'Yes',
        no: 'No',
        confirm: () => callback(item),
        cancel: () => {
        }
      }
    });
  }

  public doDeleteWorkstream(workstream) {
    this.workstreamService.deleteWorkstream(workstream.workstreamId).subscribe(r => {
      this.dialog.closeAll();
      this.ngOnInit();
    })
  }

  public doDeleteWorkstreamItem(workstreamItem) {
    this.workstreamService.deleteWorkstreamItem(workstreamItem.workstreamItemId).subscribe(r => {
      this.dialog.closeAll();
      this.ngOnInit();
    })
  }

  loadWorkStreams() {
    this.workstreamService.getWorkstreams().subscribe(result => {
      this.workstreams = result;
      for (let workstream of result) {
        if (workstream.workstreamItems.length) {
          this.updateRowGroupMetaData(workstream.workstreamItems, workstream.workstreamId);
          for (let item of workstream.workstreamItems) {
            item.controlItemSummary = item.controlItems.map(i => `${i.complianceAreaControlId}`).join(', ');
            item.descriptionSafe = (item.description || '').replace(/\<[^<]*\>/g, '');
            item.detailsSafe = (item.details || '').replace(/\<[^<]*\>/g, '');
          }
        }
        workstream.outstandingItemsCount = this.getOutstandingItems(workstream.workstreamItems).length || 0;
        workstream.overdueItemsCount = this.getOverdueItems(workstream.workstreamItems).length || 0;
      }
      this.filteredWorkstream = this.workstreams.map(ws => ({ ...ws }));

      if(this.controlItemIdFromRoute) {
        this.filterWorkstreamsByControlId();
      }
    });
  }

  filterWorkstreamsByControlId() {
    let filteredControlItems = [];

    this.controlItemService.getById(this.controlItemIdFromRoute)
      .subscribe(r => {
        this.complianceAreaControlIdFromFilter = r.complianceAreaControlId;
        filteredControlItems.push(r.complianceAreaControlId)

        const controlIds = r.subItems.map(item => item.complianceAreaControlId);
        filteredControlItems.push(...controlIds);

        this.filteredWorkstream = this.filteredWorkstream.filter(workstream => {
            const filteredItems = workstream.workstreamItems.filter(item => {
              return item.controlItems.some(control => filteredControlItems.includes(control.complianceAreaControlId));
            });

            if (filteredItems.length > 0) {
                workstream.workstreamItems = filteredItems;
                return true;
            } else {
                return false;
            }
        });

        for(let workstream of this.filteredWorkstream) {
          this.updateRowGroupMetaData(workstream.workstreamItems, workstream.workstreamId);
          this.expandedWorkstreams[workstream.workstreamId] = true;

          for(let wsItem of workstream.workstreamItems) {
            this.expandedWorkstreamItems[wsItem.workstreamItemId] = true;
          }
        }
      });
}

  duplicateWorkstreamItem(workstreamItem) {
    const clone = {...workstreamItem};
    clone.wsid = clone.wsid + ' (copy)';
    clone.workstreamItemId = 0;
    this.workstreamService.saveWorkstreamItem(clone).subscribe(r => {
      this.ngOnInit();
    })
  }

  duplicateWorkstream(workstream) {
    this.workstreamService.duplicateWorkstream(workstream.workstreamId).subscribe(r => {
      this.ngOnInit();
    })
  }

  getTenantName(): string {
    if (this.currentUser == null) {
      return null;
    }

    if (this.currentUser.role == Role.KingAdmin) {
      return Constants.RiskSpongeMaster;
    }

    return this.currentUser.tenantName;
  }

  onPanelHide() {
    this.columnVisibility = {};
    this.cols.sort((a, b) => this.columnOptions.indexOf(this.columnOptions.find(c => c.value == a)) - this.columnOptions.indexOf((this.columnOptions.find((c => c.value == b)))));
    for (let i = 0; i < this.columnOptions.length; i++) {
      if (!this.cols.find(c => c.field == this.columnOptions[i].value.field)) {
        this.columnVisibility[this.columnOptions[i].value.field] = false;
      }
    }
    this.clientProfileService.saveUserSetting("WorkstreamTable", {columnVisibility: this.columnVisibility}).subscribe(() => {
    });
  }

  importWorkstream() {
    const dialogRef = this.dialog.open(WorkstreamUploadComponent, {});

    dialogRef.afterClosed().subscribe(() => {
      this.ngOnInit();
    });
  }

  saveWorkStreamOrder(e) {
    this.workstreamService.setWorkStreamOrder(this.filteredWorkstream.map(p => p.workstreamId)).subscribe(() => {
      this.loadWorkStreams();
    })
  }

  saveWorkStreamItemOrder(e, workstreamId) {
    var workstream = this.filteredWorkstream.find(c => c.workstreamId == workstreamId);
    if (workstream) {
      this.workstreamService.setWorkStreamItemOrder(workstream.workstreamItems).subscribe(() => {
      })
    }
  }

  updateRowGroupMetaData(data, key) {
    this.rowGroupMetadata[key] = {};
    if (data) {
      let current = null;
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.type;
        if (i == 0) {
          this.rowGroupMetadata[key][rowData.workstreamItemId] = rowData.workstreamItemId;
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.type;
          if (brand === previousRowGroup) {
            this.rowGroupMetadata[key][rowData.workstreamItemId] = this.rowGroupMetadata[key][previousRowData.workstreamItemId];
          } else
            this.rowGroupMetadata[key][rowData.workstreamItemId] = rowData.workstreamItemId;
        }
      }
    }
  }

  getAllOverdueItems() {
    for (let ws of this.filteredWorkstream) {
      ws.workstreamItems = this.getOverdueItems(ws.workstreamItems);
      this.expandedWorkstreams[ws.workstreamId] = true;

      for(let wsItem of ws.workstreamItems) {
        this.expandedWorkstreamItems[wsItem.workstreamItemId] = true;
      }
    }
    this.filteredWorkstream = this.filteredWorkstream.filter(ws => ws.workstreamItems.length > 0);

    for(let workstream of this.filteredWorkstream) {
      this.updateRowGroupMetaData(workstream.workstreamItems, workstream.workstreamId);
    }
    this.isFilterSelected = true;
  }

  getOutstandingItems(wsItems: any) {
    const currentDate = new Date();
    return wsItems.filter(stream => stream.status !== "Dev Complete" &&  stream.status !== "Deployed" && currentDate <= new Date(stream.dueDate));
  }

  getOverdueItems(wsItems: any) {
    const currentDate = new Date();
    return wsItems.filter(stream => stream.status !== "Dev Complete" &&  stream.status !== "Deployed" && currentDate > new Date(stream.dueDate));
  }

  isSelected(workstreamId: string, type: string) {
    return this.selectedFilter?.workstreamId === workstreamId && this.selectedFilter?.filterType === type;
  }

  handleClickOnWorkstreamFilter(workstreamId: string, type: string) {
    if(this.isSelected(workstreamId, type)) {
      this.clearFilter();
      return;
    }
    if(!this.isFilterSelected) {
      this.setFilter(workstreamId, type);
    }
  }

  setFilter(workstreamId: string, filterType: string) {
    const workstream = this.filteredWorkstream.find(ws => ws.workstreamId === workstreamId);

    if(filterType === 'Outstanding')
      workstream.workstreamItems = this.getOutstandingItems(workstream.workstreamItems);
    else if(filterType === 'Overdue')
      workstream.workstreamItems = this.getOverdueItems(workstream.workstreamItems);

    if(workstream.workstreamItems.length > 0) {
      this.expandedWorkstreams[workstream.workstreamId] = true;
      this.filteredWorkstream = [workstream];
    }
    else {
      this.filteredWorkstream = [];
    }

    for(let workstream of this.filteredWorkstream) {
      this.updateRowGroupMetaData(workstream.workstreamItems, workstream.workstreamId);
      for(let workstreamItem of workstream.workstreamItems) {
        this.expandedWorkstreamItems[workstreamItem.workstreamItemId] = true;
      }
    }
    this.selectedFilter = { workstreamId, filterType };
    this.isFilterSelected = true;
  }

  clearFilter() {
    if(this.controlItemIdFromRoute) {
      this.router.navigate(['/workstreams']);
      this.expandedWorkstreams = {};
      this.expandedWorkstreamItems = {};
      this.selectedFilter = null;
      this.isFilterSelected = false;
      this.ngOnInit();
      return;
    }
    this.filteredWorkstream = this.workstreams.map(ws => ({ ...ws }));
    for(let workstream of this.filteredWorkstream) {
      this.updateRowGroupMetaData(workstream.workstreamItems, workstream.workstreamId);
    }

    this.expandedWorkstreams = {};
    this.expandedWorkstreamItems = {};
    this.selectedFilter = null;
    this.isFilterSelected = false;
  }

  toggleExpandedWorkstream(workstreamId: string) {
    const workstream = this.filteredWorkstream.find(ws => ws.workstreamId === workstreamId);
    const workstreamItemIds = workstream ? workstream.workstreamItems.map(item => item.workstreamItemId) : [];
    for(let wsItemId of workstreamItemIds) {
      if(this.expandedWorkstreamItems[wsItemId]) {
        delete this.expandedWorkstreamItems[wsItemId];
      }
    }
  }

  backToProject() {
    this.location.back();
  }

  onWorkstreamChange(workstream, b) {
    this.draggedItem.workstreamId = workstream.workstreamId;
    this.workstreamService.saveWorkstreamItem(this.draggedItem).subscribe(() => {
      this.loadWorkStreams();
    })
  }
}
